import { IHeadCategory } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectHeadCategories = (state: IApplicationState): IHeadCategory[] => {
  return state.promosPage.headCategories;
};
